const fileHeaders = ['File Name', 'Uploaded By', 'Upload Date'];

export {fileHeaders};